import {testIds} from '@dms/routes';
import {Main} from '@dms/shared';

import type {EagGridMaximization} from 'features/eag-grid';

import {VehicleCustomersCard} from './components/VehicleCustomersCard';

interface CustomersProps {
  maximization?: EagGridMaximization;
}

export function Customers(props: CustomersProps) {
  return (
    <Main data-testid={testIds.vehicles.customers('page')}>
      <VehicleCustomersCard maximization={props.maximization} />
    </Main>
  );
}
